import { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCharacterCompassStore } from '../store/useCharacterCompassStore';

export function useCharacterCompass() {
  const { onInit, onResetAllAnswers } = useCharacterCompassStore();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    onInit();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onResetAllAnswers();
  }, [onResetAllAnswers]);

  return {
    navigate,
  };
}
